import { css } from "@emotion/react";
import { MainTemplate } from "@/components/templates";
import { Font } from "@moneyforward/mfx_biz_react_components";
import { SendingEmailCompletedImage } from "@/components/atoms";
import { PageTitle } from "@/components/molecules";

export const RequestChangeEmailAddressCompletedPage = () => {
  return (
    <MainTemplate title={`メールを送信しました`}>
      <PageTitle mainTitle={`メールを送信しました`} />

      <SendingEmailCompletedImage />
      <div css={bottomMessage}>
        <Font variant="l" component="p">
          <div css={textCenter}>
            <div>認証メールをお送りしました。</div>
            <div>メールボックスをご確認ください</div>
          </div>
        </Font>
        <Font variant="mb">
          <div css={subTextTitleCenter}>[メールが届かないときには]</div>
          <ul css={ul}>
            <li css={list}>
              迷惑メールフォルダにはいっていないかご確認ください
            </li>
            <li css={list}>
              「moneyforward.com」のドメイン受信許可をしてください
            </li>
            <li css={list}>
              入力したメールアドレスに間違いないか確認の上、再送してください
            </li>
          </ul>
        </Font>
      </div>
    </MainTemplate>
  );
};

const ul = css({
  padding: "0",
  width: "400px",
  margin: "0 auto",
});

const list = css({
  display: "flex",
  alignItems: "baseline",
  margin: "0 0 5px",
  ":before": {
    content: '"・"',
    margin: "0 5px 0 0",
  },
});

const bottomMessage = css({
  marginTop: "52px",
});

const textCenter = css({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
});
const subTextTitleCenter = css({
  marginTop: "24px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
});
